module.exports = __webpack_public_path__ + "img/timbre.adfbb105.svg";